import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { format, differenceInSeconds } from 'date-fns';
import { useData } from '../../context/DataContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiLogIn, FiLogOut } = FiIcons;

const ClockWidget = () => {
  const { activeAttendance, clockIn, clockOut } = useData();
  const [elapsed, setElapsed] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let interval;
    if (activeAttendance) {
      interval = setInterval(() => {
        setElapsed(differenceInSeconds(new Date(), new Date(activeAttendance.startTime)));
      }, 1000);
    } else {
      setElapsed(0);
    }
    return () => clearInterval(interval);
  }, [activeAttendance]);

  const handleClockIn = async () => {
    setLoading(true);
    const result = await clockIn();
    if (!result.success) alert(result.error);
    setLoading(false);
  };

  const handleClockOut = async () => {
    setLoading(true);
    // FLOW CHANGE: No longer passing ID. clockOut handles finding active sessions.
    const result = await clockOut();
    if (!result.success) alert(result.error);
    setLoading(false);
  };

  const formatTime = (sec) => {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${h}h ${m}m ${s}s`;
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-gray-900 flex items-center">
          <SafeIcon icon={FiClock} className="w-4 h-4 mr-2 text-blue-600" /> Attendance
        </h3>
        <span className="text-xs text-gray-500">{format(new Date(), 'EEEE, MMM dd')}</span>
      </div>

      {activeAttendance ? (
        <div className="space-y-4">
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 text-center">
            <p className="text-xs text-blue-600 font-semibold uppercase tracking-wider">Clocked In</p>
            <p className="text-2xl font-mono font-bold text-blue-900 mt-1">{formatTime(elapsed)}</p>
          </div>
          <button 
            onClick={handleClockOut}
            disabled={loading}
            className="w-full flex items-center justify-center space-x-2 bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition-colors font-medium shadow-sm disabled:opacity-50"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <>
                <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                <span>Clock Out</span>
              </>
            )}
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="text-center py-2">
            <p className="text-sm text-gray-500 italic">No active shift today</p>
          </div>
          <button 
            onClick={handleClockIn} 
            disabled={loading}
            className="w-full flex items-center justify-center space-x-2 bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium shadow-sm disabled:opacity-50"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <>
                <SafeIcon icon={FiLogIn} className="w-4 h-4" />
                <span>Clock In</span>
              </>
            )}
          </button>
        </div>
      )}
    </motion.div>
  );
};

export default ClockWidget;